import React from 'react';
import ReactDOM from 'react-dom';
import './ToolbarMenu.css';

function ToolbarMenu({ buttonsToolBar = [] }) {
    const [open, setOpen] = React.useState(false);
    const buttonRef = React.useRef(null);
    const menuRef = React.useRef(null);
    const [position, setPosition] = React.useState({ top: 0, right: 0 });

    const toggleMenu = () => {
        if (!open && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + window.scrollY + 4,
                right: Math.max(8, document.documentElement.clientWidth - rect.right)
            });
        }
        setOpen(prev => !prev);
    };

    // Fecha ao clicar/tocar fora
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, []);

    const menu = open && (
        <div
            ref={menuRef}
            className="toolbar-menu"
            role="menu"
            style={{
                position: 'absolute',
                top: position.top,
                right: position.right,
                zIndex: 9999
            }}
        >
            {buttonsToolBar.map((btn, index) => (
                <div key={index}>
                    {btn}
                </div>
            ))}
        </div>
    );

    return (
        <>
            <button
                ref={buttonRef}
                onClick={toggleMenu}
                className="toolbar-menu-trigger"
                aria-label="Mais ações"
                aria-haspopup="menu"
                aria-expanded={open}
                title="Mais ações"
            >
                <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="5" cy="12" r="2" fill="currentColor" />
                    <circle cx="12" cy="12" r="2" fill="currentColor" />
                    <circle cx="19" cy="12" r="2" fill="currentColor" />
                </svg>
            </button>

            {open && ReactDOM.createPortal(menu, document.body)}
        </>
    );
}

export default ToolbarMenu;
